var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"lesson-item"},[_c('span',{staticClass:"lesson-item__index"},[_vm._v(_vm._s(_vm.index + 1))]),_c('p',[_vm._v(_vm._s(_vm.lesson.name))]),_c('div',{staticClass:"lesson-item__progress"},[_c('output',[_vm._v(_vm._s(_vm.percent)+"%")]),_c('IconProgress',{attrs:{"id":_vm.lesson.id,"progress":_vm.percent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }